import Layout from '@/page/index/'
export default [{
    path: '/wel',
    component: Layout,
    redirect: '/wel/index',
    children: [{
        path: 'index',
        name: '首页',
        component: () =>
            import ('@/page/wel')
    }]
},{
    path: '/dsrms',
    component: Layout,
    redirect: '/dsrms/index',
    children: [{
        path: 'index',
        name: '动态状态管理首页',
        component: () =>
            import ('@/views/dev/index')
    }]
},{
    path: '/sms',
    component: Layout,
    redirect: '/dsrms/index',
    children: [{
        path: 'index',
        name: '短信管理首页',
        component: () =>
            import ('@/views/dev/index')
    }]
},{
    path: '/im',
    component: Layout,
    redirect: '/im/index',
    children: [{
        path: 'index',
        name: '短信平台首页',
        component: () =>
            import ('@/views/dev/index')
    }]
}, {
    path: '/wmc',
    component: Layout,
    redirect: '/dsrms/index',
    children: [{
        path: 'index',
        name: '工友圈首页',
        component: () =>
            import ('@/views/dev/index')
    }]
}, {
    path: '/resource',
    component: Layout,
    redirect: '/dsrms/index',
    children: [{
        path: 'index',
        name: '资源管理首页',
        component: () =>
            import ('@/views/dev/index')
    }]
}, {
    path: '/sales',
    component: Layout,
    redirect: '/dsrms/index',
    children: [{
        path: 'index',
        name: '营销平台首页',
        component: () =>
            import ('@/views/dev/index')
    }]
}, {
    path: '/advert',
    component: Layout,
    redirect: '/dsrms/index',
    children: [{
        path: 'index',
        name: '广告管理首页',
        component: () =>
            import ('@/views/dev/index')
    }]
},{
    path: '/ruleAuth',
    component: Layout,
    redirect: '/dsrms/index',
    children: [{
        path: 'index',
        name: '认证系统首页',
        component: () =>
            import ('@/views/dev/index')
    }]
}, {
    path: '/work',
    component: Layout,
    redirect: '/dsrms/index',
    children: [{
        path: 'index',
        name: '工单管理首页',
        component: () =>
            import ('@/views/dev/index')
    }]
},{
    path: '/appPush',
    component: Layout,
    redirect: '/dsrms/index',
    children: [{
        path: 'index',
        name: '工友圈的首页',
        component: () =>
            import ('@/views/dev/index')
    }]
},{
    path: '/pointsMall',
    component: Layout,
    redirect: '/dsrms/index',
    children: [{
        path: 'index',
        name: '积分商城首页',
        component: () =>
            import ('@/views/dev/index')
    }]
}, {
    path: '/integral',
    component: Layout,
    redirect: '/dsrms/index',
    children: [{
        path: 'index',
        name: '积分系统首页',
        component: () =>
            import ('@/views/dev/index')
    }]
},   {
    path: '/info',
    component: Layout,
    redirect: '/info/index',
    children: [{
        path: 'index',
        name: '个人信息',
        component: () =>
            import ('@/views/info/index')
    }]
}, {
    path: '/logs',
    component: Layout,
    redirect: '/logs/index',
    children: [{
        path: 'page',
        name: '错误页面',
        component: () =>
            import ('@/page/logs/page')
    }, {
        path: 'error',
        name: '错误日志',
        component: () =>
            import ('@/page/logs/error')
    }]
}]